import {
  doc,
  setDoc,
  getDoc,
  collection,
  addDoc,
  deleteDoc,
  increment,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import { db } from "../firebase";
import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

//User side of Rating
export const AddBookRating = async (rating, isbn, user) => {
  try {
    console.log("Rating:", rating);
    console.log("ISBN:", isbn);
    const uid = user.uid;
    console.log("UID:", uid);

    const userRatingRef = doc(db, "users", uid, "Ratings", isbn);
    await setDoc(userRatingRef, {
      changes: false,
      isbn: isbn,
      rating: rating,
      timestamp: new Date(),
    });
    console.log("Rating added to user.");

    const bookRef = doc(db, "books", isbn);
    const bookSnapshot = await getDoc(bookRef);
    if (bookSnapshot.exists()) {
      const bookData = bookSnapshot.data();
      console.log("Existing Ratings:", bookData.rating);
      console.log("Rating Count:", bookData.NumberOfRatings);
      console.log("Ratings:", bookData.Ratings);
      const existingMapData = bookData.Ratings;
      existingMapData[uid] = rating;
      
      var updatedRatingsCount;
      updatedRatingsCount = Object.keys(existingMapData).length
      
      
      let totalSum = 0;
    for (const key in existingMapData) {
      const value = existingMapData[key];
      if (typeof value === 'number') {
        totalSum += value;
      }
    }
    totalSum = (totalSum)/updatedRatingsCount;

    await updateDoc(bookRef,{
      Ratings: existingMapData,
      NumberOfRatings: updatedRatingsCount,
      rating: totalSum
    })
    } else {
      console.log("Book does not exist.");
    }
  } catch (error) {
    console.error("Error:", error.message);
  }
};

const CheckUserRatedBasedOnChanges = async (user, isbn) => {
  try {
    console.log(isbn);
    const uid = user.uid;
    console.log("uid:", uid);
    try {
      const docRef = doc(db, "users", uid, "Ratings", isbn);

      // Get the document snapshot
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document changes:", docSnap.data().changes);
        return docSnap.data().changes;
      } else {
        console.log("User did not rate!");
        return false;
      }
    } catch (error) {
      console.error("Error retrieving rating to book:", error);
      return false;
    }
  } catch (error) {
    console.error("Error getting user Data:", error);
    return false;
  }
};

const incrementChanges = async (user, isbn) => {
  const uid = user.uid;
  try {
    const docRef = doc(db, "users", uid, "Ratings", isbn);

    await updateDoc(docRef, {
      changes: true,
    });
    console.log("Change incremented.");
  } catch (error) {
    console.error("Error incrementing changes in user Ratings", error);
  }
};

export const DisplayUserBookRating = async (user, isbn) => {
  try {
    console.log(isbn);
    const uid = user.uid;
    console.log("uid:", uid);
    try {
      const docRef = doc(db, "users", uid, "Ratings", isbn);

      // Get the document snapshot
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        console.log("Document snapshot:", docSnap.data().rating);
        return docSnap.data().rating;
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error retrieving rating to book:", error);
    }
  } catch (error) {
    console.error("Error getting user Data:", error);
  }
};

export const UserRated = async (user, isbn) => {
  try {
    console.log(isbn);
    const uid = user.uid;
    console.log("uid:", uid);
    try {
      const docRef = doc(db, "users", uid, "Ratings", isbn);

      // Get the document snapshot
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data().rating);
        return true;
      } else {
        console.log("User did not rate!");
        return false;
      }
    } catch (error) {
      console.error("Error retrieving rating to book:", error);
      return false;
    }
  } catch (error) {
    console.error("Error getting user Data:", error);
    return false;
  }
};

export const RemoveRating = async (user, isbn) => {
  const uid = user.uid;
  try {
    const subcollectionRef = collection(db, "users", uid, "Ratings");
    const docRef = doc(subcollectionRef, isbn);

    await deleteDoc(docRef);
    console.log(`Document successfully deleted.`);

    const bookRef = doc(db, "books", isbn);
    const bookSnapshot = await getDoc(bookRef);
    if (bookSnapshot.exists()) {
      const bookData = bookSnapshot.data();
      const existingMapData = bookData.Ratings;
      delete existingMapData[uid];
      
      var updatedRatingsCount;
      updatedRatingsCount = Object.keys(existingMapData).length
      
      
      let totalSum = 0;
    for (const key in existingMapData) {
      const value = existingMapData[key];
      if (typeof value === 'number') {
        totalSum += value;
      }
    }
    totalSum = (totalSum)/updatedRatingsCount;

    await updateDoc(bookRef,{
      Ratings: existingMapData,
      NumberOfRatings: updatedRatingsCount,
      rating: totalSum
    })

    }
    console.log("Recalculated Rating!")

  } catch (error) {
    console.error("Error deleting book rating", error);
  }
};
